import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import IndexBoard from "@/pages/home/components/IndexBoard";
import AccessWays from "@/pages/home/components/AccessWays";
import ChannelEntries from "@/pages/home/components/ChannelEntries";
import GuideSteps from "@/pages/home/components/GuideSteps";
import Collections from "@/pages/home/components/Collections";
import FaqAndSubscribe from "@/pages/home/components/FaqAndSubscribe";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <IndexBoard />
        <AccessWays />
        <ChannelEntries />
        <GuideSteps />
        <Collections />
        <FaqAndSubscribe />
      </main>
      <SiteFooter />
    </div>
  );
}